export enum MassUnitType {
  PER
}

export enum MassUnitLabelType {
  PER = 'Per'
}

export enum AreaUnitType {
  HA
}

export enum AreaUnitLabelType {
  HA = 'Ha'
}

export enum CostUnitType {
  GBP
}

export enum CostUnitLabelType {
  GBP = 'GBP'
}

export enum DirectionUnitType {
  MILESPERHR
}

export enum DirectionUnitLabelType {
  MILESPERHR = 'Miles/hr'
}

export enum TemperatureUnitType {
  CELSIUS
}

export enum TemperatureUnitLabelType {
  CELSIUS = 'Celsius'
}

export enum TimeUnitType {
  MINUTES,
  HOURS,
  DAYS,
  YEARS
}

export enum TimeUnitLabelType {
  MINUTES = 'Mins',
  HOURS = 'Hours',
  DAYS = 'Days',
  YEARS = 'Years'
}
